import { createWidgetMaps } from '@trinity/chat-components/components/WidgetGrid/WidgetMaps.js';
import { ChartVisualization } from '../Project.QuantAnalysis/components/ChartVisualization';

export const { WIDGET_COMPONENT_MAP, WIDGET_THUMBNAIL_MAP } = createWidgetMaps(ChartVisualization);
